import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Layout, Row, Col, Typography, Button, Spin } from 'antd';
import { Icon } from 'antd-mobile';
import { withTranslation } from 'react-i18next';
import './housekeepingOptIn.css';

const { Content } = Layout;
const { Text } = Typography;

@inject('housekeepingOptInStore', 'loginStore')
@observer
class HousekeepingOptInPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        const roomNo = this.props.loginStore.getRoomNo();
        if (!roomNo) {
            this.props.history.push('/login');
        }

        this.props.loginStore.authenticateGuest().then(response => {
            if (!response) {
                this.props.history.push('/login');
            }
        });

        this.props.housekeepingOptInStore.initHousekeepingOptIn();
    }

    // ON CLICK Action

    selectHousekeepingOptInOnClick = (taskId, isSelected) => {
        this.props.housekeepingOptInStore.setHousekeepingOptInIsSelected(taskId, isSelected);
    }

    housekeepingOptInOrderOnClick = () => {
        this.props.history.push('/housekeepingOptIn-confirm');
    }

    backToHomePageOnClick = () => {
        this.props.history.push('/')
    }

    render() {
        const {
            housekeepingOptIn,
            housekeepingOptInLoading
        } = this.props.housekeepingOptInStore;

        return (
            <Layout className='layout-page'>
                <Content>
                    <Row>
                        <Col span={24} className='col-header'>
                            <Row>
                                <Col span={4} className='col-header-back' onClick={this.backToHomePageOnClick}>
                                    <Icon type='left' size='lg' color='#FFF' />
                                </Col>
                                <Col span={16} className='col-header-text'>
                                    <Text className='text-header'>Housekeeping Opt-In</Text>
                                </Col>
                                <Col span={4} />
                            </Row>
                        </Col>
                    </Row>
                    <Row className='row-body-header'>
                        <Col span={24} className='col-body-header'>
                            <img src={require('../../assets/image/Banner/CleanRoom.svg')} alt='HousekeepingOptIn' />
                        </Col>
                    </Row>

                    {
                        !housekeepingOptIn
                            ?
                            <Row>
                                <Col span={24} className='housekeepingoptin-col-nodata'>
                                    <Spin spinning={true} tip='Loading data ...'>
                                    </Spin>
                                </Col>
                            </Row>
                            :
                            <Spin spinning={housekeepingOptInLoading}>
                                <Row className='row-body-content'>
                                    <Col span={1} />
                                    <Col span={22} className='housekeepingoptin-col-container'>
                                        <Row>
                                            {housekeepingOptIn.isSunday ?
                                                <Col span={24} className='housekeepingoptin-col-selected' onClick={() => this.props.housekeepingOptInStore.setHousekeepintOptInIsSunday(false)}>Sunday</Col>
                                                :
                                                <Col span={24} className='housekeepingoptin-col' onClick={() => this.props.housekeepingOptInStore.setHousekeepintOptInIsSunday(true)}>Sunday</Col>
                                            }
                                        </Row>
                                        <Row>
                                            {housekeepingOptIn.isMonday ?
                                                <Col span={24} className='housekeepingoptin-col-selected' onClick={() => this.props.housekeepingOptInStore.setHousekeepintOptInIsMonday(false)}>Monday</Col>
                                                :
                                                <Col span={24} className='housekeepingoptin-col' onClick={() => this.props.housekeepingOptInStore.setHousekeepintOptInIsMonday(true)}>Monday</Col>
                                            }
                                        </Row>
                                        <Row>
                                            {housekeepingOptIn.isTuesday ?
                                                <Col span={24} className='housekeepingoptin-col-selected' onClick={() => this.props.housekeepingOptInStore.setHousekeepintOptInIsTuesday(false)}>Tuesday</Col>
                                                :
                                                <Col span={24} className='housekeepingoptin-col' onClick={() => this.props.housekeepingOptInStore.setHousekeepintOptInIsTuesday(true)}>Tuesday</Col>
                                            }
                                        </Row>
                                        <Row>
                                            {housekeepingOptIn.isWednesday ?
                                                <Col span={24} className='housekeepingoptin-col-selected' onClick={() => this.props.housekeepingOptInStore.setHousekeepintOptInIsWednesday(false)}>Wednesday</Col>
                                                :
                                                <Col span={24} className='housekeepingoptin-col' onClick={() => this.props.housekeepingOptInStore.setHousekeepintOptInIsWednesday(true)}>Wednesday</Col>
                                            }
                                        </Row>
                                        <Row>
                                            {housekeepingOptIn.isThursday ?
                                                <Col span={24} className='housekeepingoptin-col-selected' onClick={() => this.props.housekeepingOptInStore.setHousekeepintOptInIsThursday(false)}>Thursday</Col>
                                                :
                                                <Col span={24} className='housekeepingoptin-col' onClick={() => this.props.housekeepingOptInStore.setHousekeepintOptInIsThursday(true)}>Thursday</Col>
                                            }
                                        </Row>
                                        <Row>
                                            {housekeepingOptIn.isFriday ?
                                                <Col span={24} className='housekeepingoptin-col-selected' onClick={() => this.props.housekeepingOptInStore.setHousekeepintOptInIsFriday(false)}>Friday</Col>
                                                :
                                                <Col span={24} className='housekeepingoptin-col' onClick={() => this.props.housekeepingOptInStore.setHousekeepintOptInIsFriday(true)}>Friday</Col>
                                            }
                                        </Row>
                                        <Row>
                                            {housekeepingOptIn.isSaturday ?
                                                <Col span={24} className='housekeepingoptin-col-selected' onClick={() => this.props.housekeepingOptInStore.setHousekeepintOptInIsSaturday(false)}>Saturday</Col>
                                                :
                                                <Col span={24} className='housekeepingoptin-col' onClick={() => this.props.housekeepingOptInStore.setHousekeepintOptInIsSaturday(true)}>Saturday</Col>
                                            }
                                        </Row>
                                    </Col>
                                    <Col span={1} />
                                </Row>
                            </Spin>
                    }

                    <Row>
                        <Col span={24} className='col-body-footer-confirm'>
                            <Row>
                                <Col span={1} />
                                <Col span={22} >
                                    <Button className='btn-body-footer-confirm-selected' onClick={() => this.props.housekeepingOptInStore.updateHousekeepingOptIn()}>Save</Button>
                                </Col>
                                <Col span={1} />
                            </Row>
                        </Col>
                    </Row>
                </Content>
            </Layout>
        )
    }
}

export default withTranslation()(HousekeepingOptInPage)